import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

export interface StoreInfo {
  classes: {
    header?: Array<string>;
    headerContainer?: Array<string>;
    headerMobile?: Array<string>;
    headerMenu?: Array<string>;
    aside?: Array<string>;
    asideMenu?: Array<string>;
    asideToggle?: Array<string>;
    toolbar?: Array<string>;
    toolbarContainer?: Array<string>;
    content?: Array<string>;
    contentContainer?: Array<string>;
    footerContainer?: Array<string>;
    sidebar?: Array<string>;
    pageTitle?: Array<string>;
  };
}

/**
 * BodyModule — manages document.body classes/attributes for the layout system.
 *
 * These actions directly manipulate document.body, which is a layer violation
 * (store actions shouldn't touch the DOM). However, they are deeply integrated
 * into the layout system (called from KTLayout, KTLoader, etc.) and removing
 * them would require refactoring the entire layout layer.
 *
 * TODO: Migrate to a useBodyClass() composable when the layout system is modernized.
 */
@Module
export default class BodyModule extends VuexModule implements StoreInfo {
  classes: Record<string, string[]> = {};

  /**
   * Get current page title
   * @returns string
   */
  get getClasses() {
    return (position?: string) => {
      if (typeof position !== "undefined") {
        return this.classes[position];
      }
      return this.classes;
    };
  }

  @Mutation
  [Mutations.SET_CLASSNAME_BY_POSITION](payload: {
    position: string;
    className: string;
  }) {
    const { position, className } = payload;
    const classes = this.classes[position] ?? [];
    classes.push(className);
    this.classes[position] = classes;
  }

  @Action
  [Actions.ADD_BODY_CLASSNAME](className: string) {
    document.body.classList.add(className);
  }

  @Action
  [Actions.REMOVE_BODY_CLASSNAME](className: string) {
    document.body.classList.remove(className);
  }

  @Action
  [Actions.ADD_BODY_ATTRIBUTE](payload: {
    qulifiedName: string;
    value: string;
  }) {
    const { qulifiedName, value } = payload;
    document.body.setAttribute(qulifiedName, value);
  }

  @Action
  [Actions.REMOVE_BODY_ATTRIBUTE](payload: { qulifiedName: string }) {
    const { qulifiedName } = payload;
    document.body.removeAttribute(qulifiedName);
  }

  @Action
  [Actions.ADD_CLASSNAME](payload: { position: string; className: string }) {
    this.context.commit(Mutations.SET_CLASSNAME_BY_POSITION, payload);
  }
}
